import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";

const keyList = {
    smsUpdate : 'EXPERTISE_UPDATE',
    smsDelete : 'EXPERTISE_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        expertise: [],
        expertise_details: {},

        submitSuccess: false,
        expertiseLoading: false,
        expertiseError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_EXPERTISE(state, results) {
            state.expertise = results;
        },

        GET_EXPERTISE_DETAILS(state, results) {
            state.expertise_details = results;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        EXPERTISE_LOADING (state, loading) {
            state.expertiseLoading = loading;
        },

        EXPERTISE_ERROR (state, hasError) {
            state.expertiseError = hasError;
        }
    },

    actions: {
        async addExpertise ({commit, dispatch}, payload) {
            commit('EXPERTISE_LOADING', true);
            commit('EXPERTISE_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let response = await axios.post(V1API.create_expertise, payload.expertise, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchExpertise')
                return response

            } catch (e) {
                commit('EXPERTISE_ERROR', true);
            } finally {
                commit('EXPERTISE_LOADING', false);
            }
        },

        async fetchExpertise ({ commit }) {
            commit('EXPERTISE_LOADING', true);
            commit('EXPERTISE_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let result = await axios.get(V1API.expertise_list, config);
                let response = result.data.data
                commit('SET_EXPERTISE', response);
                return result
            } catch(error) {
                commit('EXPERTISE_ERROR', true);
            } finally {
                commit('EXPERTISE_LOADING', false);
            }
        },

        async getDetails ({ commit }, payload) { 
            let response = await axios.get(V1API.get_expertise_details + payload).then(result => {
                let items = result.data.data
                commit('GET_EXPERTISE_DETAILS', items)
                return result
            })
            return response
        },

        async updateExpertise ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let response = await axios.patch(V1API.update_expertise + payload.id, payload.expertise, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchExpertise')
                return response

            } catch (e) {
                commit('EXPERTISE_ERROR', true);
            } finally {
                commit('EXPERTISE_LOADING', false);
            }
        },

        async deleteExpertise({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            let response = await axios.delete(V1API.delete_expertise + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchExpertise')
            return response
        }
    },

    getters: {}
}
